import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

// import { getToken } from "@/utils/Token"
Vue.use(VueRouter);

const router = new VueRouter({
	// mode: 'history',
	routes,
});

const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};

VueRouter.prototype.replace = function replace(location) {
	return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
	
	// if(getToken() !== null && getToken() !== ""){
	//      if(to.path == '/login'){
	//        next('/')
	//      }else{
	//        next();
	//      }
	// }else{
	//   if(to.path == "/login"){
	//     next();
	//   }else{
	//     next("/login")
	//   }
	// }
	next();
});

export default router;
